import React from "react";
import DoughnutChart from "./DashboardMainChartsInfo";
// import { dataChart1, dataChart2, option } from "./DashboardMainChartsInfo";

// Styles
import styles from "./DashboardMain.module.css";

const DashboardMainCharts = ({ dashboardData }) => {

    const dataChartConfig = {
        backgroundColor: [
            '#FAE77E',
            '#FFB26A',
            '#73DCF3',
            '#21409a'
        ],
        borderColor: [
            '#FAE77E',
            '#FFB26A',
            '#73DCF3',
            '#21409a'
        ],
        borderRadius: 0,
        cutout: "70%",
        animation: true,
    }

    const dataChart1 = {
        labels: ['تجاری', "باغ/ویلا", 'خدماتی', 'مسکونی'],
        datasets: [
            {
                data: [dashboardData?.commercialLeaseCount, dashboardData?.villaRentCount, dashboardData?.serviceRentCount, dashboardData?.residentialRentalCount],
                ...dataChartConfig,
            },
        ],
    };

    const dataChart2 = {
        labels: ['تجاری', "باغ/ویلا", 'خدماتی', 'مسکونی'],
        datasets: [
            {
                data: [dashboardData?.commercialSalesCount, dashboardData?.villaSalesCount, dashboardData?.serviceSalesCount, dashboardData?.residentialSalesCount],
                ...dataChartConfig,
            },
        ],
    };

    return (
        <div dir="rtl" className={`mt-4 pt-3 mx-md-4 px-2`}>
            <div className={`w-100 d-flex justify-content-between`}>
                <h5 className={`${styles.total_title_dashboardMain_box}`}> آمار فایل ها </h5>
            </div>

            <div className={`mt-3 d-flex justify-content-between flex-wrap`}>
                <div className={`p-4 ${styles.total_chart_box}`}>
                    <h5 className={`pt-1 pb-4 text-right ${styles.title_chart_box}`}> رهن و اجاره </h5>
                    <div className={`position-relative ${styles.parent_doughnut_chart}`}>
                        <DoughnutChart chartType="doughnut" data={dataChart1} />
                        <span className={`position-absolute text-center w-100 ${styles.sum_title_center_chart}`}> تعداد کل فایل ها: </span>
                    </div>
                </div>

                <div className={`p-4 ${styles.total_chart_box}`}>
                    <h5 className={`pt-1 pb-4 text-right ${styles.title_chart_box}`}> فروش </h5>
                    <div className={`position-relative ${styles.parent_doughnut_chart}`}>
                        <DoughnutChart chartType="doughnut" data={dataChart2} />
                        <span className={`position-absolute text-center w-100 ${styles.sum_title_center_chart}`}> تعداد کل فایل ها: </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardMainCharts;